import { ENDPOINT } from "../../constants/endpoint.js"
import axios from 'axios'

const state = {
  error: null,
  registrationsForInstallation: []
};

const mutations = {
  ERROR:(state,error)=>{ 
    state.error = error
  },
  SET_REGISTRATION_FOR_INSTALL:(state, data)=>{
    state.registrationsForInstallation = data
  }
};

const actions = {
  async getRegistrationForInstallation ({ commit }) {
    const config = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    const url = ENDPOINT.GET_REGISTRATION_FOR_INSTALL;
    await axios
      .get(url) //, null, config
      .then((response) => {
        const data = response.data;
        console.log("vessel all", data);
        commit("SET_REGISTRATION_FOR_INSTALL", data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {

      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};